import Monitoring from '../../views/monitoring/Monitoring.vue'
import MonitoringAudiences from '../../views/monitoring/MonitoringAudiences.vue'
import MonitoringTransfers from '../../views/monitoring/MonitoringTransfers.vue'

const routes = {
    path: '/:account_id/monitoring',
    name: 'monitoring',
    redirect: { name: 'monitoring-audiences' },
    component: Monitoring,
    children: [
        {
            path: 'audiences',
            name: 'monitoring-audiences',
            component: MonitoringAudiences
        },
        {
            path: 'transfers',
            name: 'monitoring-transfers',
            component: MonitoringTransfers
        },
    ]
}

export default routes
